(() => {
  const config = document.currentScript?.dataset || {};
  window.SHOPIFY_PERMANENT_DOMAIN = config.shopifyPermanentDomain || '';
  window.SHOPIFY_CUSTOMER_ID = config.shopifyCustomerId || '';
  window.SHOPIFY_CUSTOMER_EMAIL = config.shopifyCustomerEmail || '';

  const businessHoursData = {
    timezone: config.businessHoursTimezone || 'US/Eastern',
    business_hours: [{ days: '1,2,3,4,5,6,7', from_time: '09:00', to_time: '21:50' }],
  };

  const brandName = config.brandName || 'Steve Madden';
  const privacyPolicyLink = config.privacyPolicyLink || 'https://www.stevemadden.com/pages/privacy-policy';
  const introMessage = `By using this chat feature, you consent to the recording and use of information about you and this chat session by ${brandName} or any authorized service provider acting solely on ${brandName}’s behalf. ${brandName} may use or disclose this information in accordance with its <a href="${privacyPolicyLink}" target="_blank">Privacy Policy<a>. If you do not consent to these terms, please do not use this chat feature and reach out to us via email or by phone. Your continued interaction with, or submission of information to, this chat feature will be deemed to be your acceptance of ${brandName}’s <a href="${privacyPolicyLink}" target="_blank">Privacy Policy<a>.`;

  const duringBusinessHours = (hoursData) => {
    if (!window.moment) return true;

    const accountTimezone = hoursData.timezone;
    const localNow = window.moment();

    return hoursData.business_hours.some((businessHour) => {
      const businessHoursDays = businessHour.days.split(',');

      return businessHoursDays.some((businessHourDay) => {
        const day = window.moment().tz(accountTimezone).startOf('week').add(businessHourDay % 7, 'days');
        const fromTime = day.clone()
          .add(businessHour.from_time.split(':')[0], 'hours')
          .add(businessHour.from_time.split(':')[1], 'minutes');
        const toTime = day.clone()
          .add(businessHour.to_time.split(':')[0], 'hours')
          .add(businessHour.to_time.split(':')[1], 'minutes');

        return fromTime <= localNow && localNow < toTime;
      });
    });
  };

  const removeGorgiasChat = (hoursData) => {
    const initGorgiasChatPromise = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise((resolve) => {
        window.addEventListener('gorgias-widget-loaded', () => resolve());
      });

    initGorgiasChatPromise.then(() => {
      window.GorgiasChat.updateTexts({
        requireEmailCaptureIntro: `Hey there! ${introMessage}`,
        contactFormIntro: `Hey there! ${introMessage}`,
        contactFormSSPUnsuccessfulAskAdditionalMessage: `Hey there! ${introMessage}`,
        waitTimeLongNoEmail: `Thank you for your patience. ${introMessage}`,
        waitTimeMediumNoEmail: `Thanks for reaching out! Leave us your email and an agent will get back to you in about {waitTime} minutes. ${introMessage}`,
        waitTimeShortNoEmail: `Thanks for reaching out! ${introMessage}`,
      });

      window.GorgiasChat.updateSSPTexts({
        sorryToHearThatEmailRequired: introMessage,
      });

      if (!duringBusinessHours(hoursData)) {
        document.querySelector('#gorgias-chat-container')?.remove();
      }

      const sspDict = {
        needHelp: '',
        sendUsAMessage: 'Promo, product & other questions',
      };

      const gorgiasChatInterval = window.setInterval(() => {
        if (
          window.GorgiasChat
          && Object.prototype.hasOwnProperty.call(window.GorgiasChat, 'updateSSPTexts')
          && Object.prototype.hasOwnProperty.call(window.GorgiasChat, 'updateTexts')
        ) {
          window.clearInterval(gorgiasChatInterval);
          window.GorgiasChat.updateSSPTexts(sspDict);
        }
      }, 200);

      const maxRepetitions = 60;
      let repetitionCount = 0;
      let isWindowStyleAppended = false;
      const gorgiasChatIntervalStyle = window.setInterval(() => {
        const container = document.querySelector('#gorgias-chat-container');
        const chatWindowHead = container?.querySelector('#chat-window')?.contentWindow.document.querySelector('head');
        const chatCampaignsHead = container?.querySelector('#chat-campaigns')?.contentWindow.document.querySelector('head');

        if (chatWindowHead?.children.length && !isWindowStyleAppended) {
          const buttonStyle = document.createElement('style');
          buttonStyle.textContent = `
    .start-chat-footer button.gg-button.primary {
    --btn-background-color: transparent;
    --btn-background-color-hover: transparent;
    --btn-color: black;
    --btn-color-hover: black;
    }

    .start-chat-footer h2 {
    display: none;
    }

    .start-chat-footer button.gg-button > svg {
    display: none;
    }
    `;
          chatWindowHead.appendChild(buttonStyle);
          isWindowStyleAppended = true;
        }

        if (chatCampaignsHead?.children.length) {
          window.clearInterval(gorgiasChatIntervalStyle);

          const campaignStyles = document.createElement('style');
          campaignStyles.textContent = '.whatyouwanttochange {property: value}';
          chatCampaignsHead.appendChild(campaignStyles);
        }

        repetitionCount += 1;
        if (repetitionCount === maxRepetitions) {
          window.clearInterval(gorgiasChatIntervalStyle);
        }
      }, 100);
    }).catch((error) => {
      console.error('Error initializing Gorgias Chat:', error);
    });
  };

  removeGorgiasChat(businessHoursData);
})();
